var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bv-row",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"align-v":"center"}},[_c('h1',[_vm._v("Oops!")]),_c('p',[_vm._v("Looks like you don't have permission to view this page!")]),_c('router-link',{attrs:{"to":{ name: 'Login' }}},[_vm._v("Take me to login.")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }